import React from 'react';
import FancyButton from '../FancyButton';
import '../FancyButton.css';

interface DebugButtonProps {
  onClick: () => void;
}

const DebugButton: React.FC<DebugButtonProps> = ({ onClick }) => {
  return (
    <FancyButton onClick={onClick} variant="yellow">
      DEBUG
    </FancyButton>
  );
};

export default DebugButton;
